module.exports = __webpack_public_path__ + "img/phpstorm.cc3f8435.png";